// extracted by mini-css-extract-plugin
export default {"row":"aXU3aIRX8feCuIRn1cNA"};